<script lang="ts">
    // Shared Components
    import EditorialCard from '@amp/web-app-components/src/components/lockups/EditorialCard/EditorialCard.svelte';

    // Components
    import StaticPlayButton from '~/components/jet/buttons/StaticPlayButton.svelte';

    // Utilities
    import {
        isExternalAction,
        handleClickAction,
        isCompoundExternalAction,
    } from '~/actions/click-action';
    // import type { Action, FlowcaseLockup } from '~/jet/models';
    // import StaticPlayButton from '~/components/jet/buttons/StaticPlayButton.svelte';
    // import { playButtonAriaLabel } from '~/utils/play-button';
    import { getI18n } from '~/stores/i18n';
    import { extractActionHref } from '~/jet/utils';
    import type { Action } from '~/jet/models';

    // Types
    import type { Lockup } from '@jet-app/music-classical/models/section/Lockup';

    const i18n = getI18n();

    export let item: Lockup;

    $: eyebrowText = item.addition;
    $: title = item.title;
    $: subtitle = item.subtitle;
    // $: accessibilityLabel = item.accessibilityLabel;
    $: artwork = item.artwork;
    $: description = item.description;
    $: clickAction = item.segue;
    $: coverArtwork = item.coverArtwork;
    // $: isVideo = [
    //     'artistUploadedVideo',
    //     'uploadedVideo',
    //     'musicVideo',
    // ].includes(item.contentDescriptor?.kind);
    $: isVideo = false;
    // Accessible label passed to Play button (with "Explicit" prefix if needed)
    $: ariaPlayButtonText = title
        ? $i18n.t('ASE.Web.MusicClassical.VO.PlayLabel', { content: title })
        : $i18n.t('ASE.Web.MusicClassical.Play');
    $: hasStandaloneAction = !description && !coverArtwork && !!item.playAction;

    const deriveLinkAction = (action: Action | null) => {
        // TODO: rdar://157049993 ([Classical on Web] - Editorial Stations: Station Page/Route)
        if (item.playAction?.items?.[0].type === 'radioStation') {
            return null;
        }

        return {
            url: extractActionHref(action) ?? '#',
            isExternal:
                isExternalAction(action) || isCompoundExternalAction(action),
        };
    };

    const handleActionClick = (e: CustomEvent<{ event: MouseEvent }>): void => {
        handleClickAction(e.detail.event, clickAction);
    };
</script>

<div class="editorial-card-classical">
    <EditorialCard
        {eyebrowText}
        {title}
        {subtitle}
        {description}
        {coverArtwork}
        {artwork}
        {isVideo}
        {hasStandaloneAction}
        multilineTitle={true}
        linkAction={deriveLinkAction(clickAction)}
        on:link-click={handleActionClick}
    >
        <svelte:fragment slot="play-button">
            {#if item.playAction}
                <StaticPlayButton
                    playAction={item.playAction}
                    ariaLabel={ariaPlayButtonText}
                    isInChin={false}
                />
            {/if}
        </svelte:fragment>
    </EditorialCard>
</div>

<style lang="scss">
    .editorial-card-classical {
        display: contents;

        :global(.editorial-card__title) {
            font: var(--title-2-semibold-serif);
        }
    }
</style>
